
import { useState, useEffect } from 'react';
import { maintenanceAlerts } from '@/components/dashboard/maintenance/data/maintenanceData';

export interface MaintenanceHistoryItem {
  date: string;
  action: string;
  technician: string;
  status: string;
  findings: string;
}

export const useMaintenanceHistory = (selectedDevice: { id: string; type: string } | null) => {
  const [maintenanceHistory, setMaintenanceHistory] = useState<MaintenanceHistoryItem[]>([]);

  useEffect(() => {
    if (selectedDevice) {
      const deviceAlerts = maintenanceAlerts.filter(
        alert => alert.deviceId === selectedDevice.id
      );
      
      const baseHistory = [
        { 
          date: '2024-03-15', 
          action: 'Routine inspection', 
          technician: 'John Smith', 
          status: 'Completed',
          findings: 'No issues found'
        },
        { 
          date: '2024-02-12', 
          action: 'Firmware update', 
          technician: 'Sarah Johnson',
          status: 'Completed',
          findings: 'Updated to version 3.2.1'
        },
        { 
          date: '2024-01-05', 
          action: 'Battery replacement', 
          technician: 'Mike Davis',
          status: 'Completed',
          findings: 'Replaced main backup battery'
        }
      ];
      
      if (deviceAlerts.length > 0) {
        deviceAlerts.forEach(alert => {
          if (!alert.issue) return;
          
          baseHistory.unshift({
            date: alert.reportDate,
            action: `Maintenance for: ${alert.issue}`,
            technician: 'AI Dispatch System',
            status: 'Scheduled',
            findings: alert.aiPrediction || 'Maintenance required based on system alert'
          });
        });
      }
      
      baseHistory.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
      
      setMaintenanceHistory(baseHistory);
    }
  }, [selectedDevice]);

  const getNextMaintenance = () => {
    const scheduledMaintenance = maintenanceHistory.find(item => item.status === 'Scheduled');
    if (scheduledMaintenance) {
      return new Date(scheduledMaintenance.date).toLocaleDateString();
    }
    return new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString();
  };

  return {
    maintenanceHistory,
    getNextMaintenance
  };
};
